import { Event } from "./Event"
import { Institution } from "./Institution"
import { ELVData } from "./ELVData"
import { ClaimAudit } from "./ClaimAudit"

/** Type that represents the calculated travel costs */
export interface TravelCosts {
    sourceCountry      : string,
    destinationCountry : string,
    travelType         : number,
    distance           : number,
    amount             : number,
    sourceCoordinates  : number[],
    destinationCoordinates: number[] 
}

/** Type that represents the calculated accommodation costs */
export interface AccommodationCosts {
    nights     : number,
    amount     : number,
    totalAmount: number,
    country    : string
}

/** Enum Type that describes the current status of a claim */
export const enum ClaimStatus
{
    UNDEFINED = -1,

    Saved       = 0,
    Requested   = 1,
    ApprovalRun = 2,
    Paid        = 3,
    Rejected    = 5,
    Deleted     = 6
}

/** Type that represents a filled claim */
export interface Claim {
    guid          : string,
    identifier    : string,
    status        : ClaimStatus, 
    firstname     : string,
    lastname      : string, 
    email         : string,
    phone         : string,
    institution   : Institution,
    elvData?      : ELVData,
    event         : Event,
    confirmed     : boolean,
    confirmDate?  : Date,
    submitted     : Date,
    audits        : ClaimAudit[],
    calculatedTravelCosts?        : TravelCosts | null,
    calculatedAccommodationCosts? : AccommodationCosts | null,
    /* Reject Informationen */
    rejectReason?: string,
    othertxt?:     string
}

/** Type that represents a struct for sending data 
 *  to the api interface via axios POST */
export interface PostClaim {

    eventId     : number, 
    firstname   : string,
    lastname    : string,
    email       : string,
    phone       : string,
    institution : string,
    street      : string, 
    postalCode  : string, 
    city        : string, 
    countryId   : number, 
    latitude    : number, 
    longitude   : number, 
    travelType  : number, 
    nightsSpend : number
}

/** Type that represents a struct for sending data 
 *  to the api interface via axios PUT */
export interface UpdateClaim
{
    guid         : string,
    confirmed    : boolean,
    status?      : ClaimStatus,
    rejectReason?: RejectReason,
    othertxt?    : string
}

/** Type that represents a preview calulcation for 
 *  submitted geo-infos from api interface */
export interface CalculationPreview {
    distance     : number,
    tAmount      : number, 
    travelType   : number, 
    nights       : number, 
    aAmount      : number, 
    aAmountTotal : number
}

/** Type that represents filter options. */
export interface ClaimFilter {
    status? : number, 
    email?  : string,
    number? : string
}

/** Type that represents different reject reasons. */
export const enum RejectReason {

    UNDEFINED = -1,

    /** Participant has not signed the check-in list. */
    NoParticipation = 0,

    /** Registration fee has not been paid. */
    FeeNotPaid = 1,

    /** Participant is EU employer. No eligble for unit costs. */
    Ineligible_EUEmployee = 2,

    /** Country is not included in the project framework. */
    Ineligible_CountryNotIncluded = 3,

    /** Other reason, has to specified by othertxt field */
    Other = 4
}